var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.47282 17.1768L1.64959 17.3536L1.82637 17.1768L9 10.0031L16.1736 17.1768L16.3504 17.3536L16.5272 17.1768L17.1768 16.5272L17.3536 16.3504L17.1768 16.1736L10.0031 9L17.1768 1.82637L17.3536 1.64959L17.1768 1.47282L16.5272 0.823223L16.3504 0.646447L16.1736 0.823223L9 7.99685L1.82637 0.823223L1.64959 0.646447L1.47282 0.823223L0.823223 1.47282L0.646447 1.64959L0.823223 1.82637L7.99685 9L0.823223 16.1736L0.646447 16.3504L0.823223 16.5272L1.47282 17.1768Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayDelete);
export default __webpack_public_path__ + "static/media/gray-delete.147c8755c8e5b9cc4ccabcf0c63b779a.svg";
export { ForwardRef as ReactComponent };